<template>
  <div class="TumengQRCodeEdit myQREdit">
    <el-tabs :stretch="true" value="style">
      <el-tab-pane
        :label="$t('lcd.Editor.Style')"
        name="style"
        class="style-pane"
      >
        <attr-row
          :label="$t('lcd.Editor.Layer Name') + ' : ' + conf.name"
        ></attr-row>
        <attr-row :label="$t('lcd.Editor.Position and Size')">
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.left"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeX"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">X</div>
              </template>
            </el-input>
            <el-input
              v-model="conf.top"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeY"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">Y</div>
              </template>
            </el-input>
          </div>
          <div style="height: 5px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.width"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeW"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">W</div>
              </template>
            </el-input>
            <el-input
              v-model="conf.height"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeH"
            >
              <template slot="prepend"
                ><div style="width: 12px; text-align: center">H</div></template
              >
            </el-input>
          </div>
        </attr-row>

        <!-- 编码内容 -->
        <attr-row :label="$t('lcd.Editor.Text')">
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.text"
              size="mini"
              :placeholder="$t('lcd.Editor.Please Input Text')"
              style="width: 49%"
            ></el-input>
            <el-select
              v-model="conf.datasetField"
              size="mini"
              clearable
              filterable
              :placeholder="$t('lcd.Editor.Please Select Data Field')"
              style="width: 49%"
              v-if="templateType != 1"
              :disabled="conf.isDeviceCode"
            >
              <el-option
                v-for="field in goodsFields"
                :key="field.value"
                :label="field.label"
                :value="field.value"
              />
            </el-select>
          </div>
          <!-- 是否为设备码 -->
          <div style="height: 8px;"></div>
          <el-checkbox v-model="conf.isDeviceCode" @change="changeIsDeviceCode">
            {{ $t("lcd.Editor.isDeviceCode") }}
          </el-checkbox>
        </attr-row>

        <attr-row :label="$t('lcd.Editor.Encoding Type')">
          <el-select
            v-model="conf.encodingType"
            size="small"
            style="width: 100%"
          >
            <el-option
              v-for="item in qrcodeList"
              :key="item.id"
              :value="item.value"
              :label="item.value"
            />
          </el-select>
        </attr-row>
        <attr-row
          :label="$t('lcd.Editor.Content Color')"
          class="ownButtonGroup th dir"
        >
          <div style="display: flex" v-if="!pageColor">
            <div style="display: flex; align-items: center">
              <i
                class="icon iconfont icon-zitiyanse"
                style="font-size: 12px; margin: 0 6px 0 0; color: #000"
              ></i>
              <el-color-picker
                v-model="conf.fontColor"
                show-alpha
                :predefine="predefineColors"
                size="mini"
              />
            </div>
            <div style="display: flex; align-items: center">
              <i
                class="icon iconfont icon-beijingse"
                style="font-size: 12px; margin: 0 6px 0 12px; color: #000"
              ></i>
              <el-color-picker
                v-model="conf.bgColor"
                show-alpha
                :predefine="predefineColors"
                size="mini"
              />
            </div>
          </div>
          <div class="EditorEslColorList"  v-if="pageColor" style="display: flex; align-items: center">
            <i
              class="icon iconfont icon-zitiyanse"
              style="font-size: 12px; margin: 0 6px 0 0; color: #000"
            ></i>
            <i v-for="(c, index) in colorList" :key="c.id">
              <span
                v-if="c.flag.includes(pageColor)"
                @click="changeFontColor(index)"
                class="colorLi"
                :style="{ background: c.color }"
              ></span>
            </i>
          </div>
          <div class="EditorEslColorList" style="margin-top: 8px; display: flex; align-items: center" v-if="pageColor">
            <i
              class="icon iconfont icon-beijingse"
              style="font-size: 12px; margin: 0 6px 0 0; color: #000"
            ></i>
            <i v-for="(c, index) in colorList" :key="c.id">
              <span
                v-if="c.flag.includes(pageColor)"
                @click="changeBgColor(index)"
                class="colorLi"
                :style="{ background: c.color }"
              ></span>
            </i>
            <img @click="conf.bgColor = 'rgba(0,0,0,0)'" :src="transparentBg" style="width: 18px;height:18px;">
          </div>
        </attr-row>

        <!-- <attr-row
          :label="$t('lcd.Editor.Rotate')"
          :height="38"
          class="custom-smaller-slider-btn2"
        >
          <el-slider v-model="conf.rotate" :min="0" :max="360" />
          <el-input-number
            v-model="conf.rotate"
            controls-position="right"
            :min="0"
            :max="360"
            size="mini"
          />
        </attr-row> -->

        <!-- <attr-row
          :label="$t('lcd.Editor.Border Radius')"
          :height="38"
          class="custom-smaller-slider-btn2"
        >
          <el-slider v-model="conf.borderRadius" :step="1" :min="0" :max="50" />
          <el-input-number
            v-model="conf.borderRadius"
            controls-position="right"
            :min="0"
            :max="50"
            size="mini"
          />
        </attr-row> -->

        <!-- 显示逻辑 -->
        <attr-row
          :label="$t('lcd.Editor.isShow')"
          class="tt"
          style="position: relative"
          v-if="templateType != 1"
        >
          <el-radio-group v-model="conf.hide">
            <el-radio size="mini" :label="true">{{
              $t("lcd.Editor.hide text")
            }}</el-radio>
            <el-radio size="mini" :label="false">{{
              $t("lcd.Editor.show text")
            }}</el-radio>
          </el-radio-group>
          <!-- {{conf.showLogic}} -->
          <el-button
            class="logicBtn"
            type="text"
            size="mini"
            @click.native="showLogicDialog"
            >{{ $t("lcd.Editor.show logic") }}</el-button
          >
        </attr-row>
      </el-tab-pane>
    </el-tabs>
    <LogicDialog
      :logicDetail="conf.showLogic"
      ref="logicRef"
      @getLogic="getLogic"
    ></LogicDialog>
  </div>
</template>

<script>
import store from "../../../store/index.js";
import AttrRow from "../../tumeng-attr-row/src/index.vue";
import {
  qrcodeList,
  predefineColors,
  colorList,
} from "../../../utils/constant.js";
import LogicDialog from "../../tumeng-display/src/index.vue";
import transparentBg from "../../../assets/imgs/icon-tr-bg.png";

export default {
  name: "TumengQRCodeEdit",
  props: {
    goodsFields: {
      type: Array,
      default: [],
    },
  },
  components: {
    AttrRow,
    LogicDialog,
  },
  data() {
    return {
      transparentBg,
      qrcodeList,
      predefineColors,
      colorList,
      //编码类型
      state: store.state,
      canvasWidth: store.state.programInfo.width,
      canvasHeight: store.state.programInfo.height,
    };
  },
  computed: {
    templateType() {
      return store.state.programInfo.templateGroup;
    },
    pageColor() {
      return this.state.programInfo.color ? this.state.programInfo.color : "";
    },
    conf() {
      return store.state.activeComponent;
    },
    fields() {
      let fields = null;
      // if (store.state.programInfo.templateGroupId == 0) {
      //   fields = JSON.parse(store.state.programInfo.goodsFields);
      // }
      if (fields) {
        return fields;
      }
      return undefined;
    },
  },
  methods: {
    changeRangeX(e) {
      console.log("X", e);
      console.log(this.canvasWidth, this.canvasHeight);
      let confX = +e;
      if (confX > this.canvasWidth - this.conf.width) {
        confX = this.canvasWidth - this.conf.width;
      }
      if (confX < 0) {
        confX = 0;
      }
      this.conf.left = confX;
    },
    changeRangeY(e) {
      let confY = +e;
      if (confY > this.canvasHeight - this.conf.height) {
        confY = this.canvasHeight - this.conf.height;
      }
      if (confY < 0) {
        confY = 0;
      }
      this.conf.top = confY;
    },
    changeRangeW(e) {
      let confW = +e;
      if (confW > this.canvasWidth - this.conf.left) {
        confW = this.canvasWidth - this.conf.left;
      }
      if (confW < 0) {
        confW = 0;
      }
      this.conf.width = confW;
    },
    changeRangeH(e) {
      let confH = +e;
      if (confH > this.canvasHeight - this.conf.top) {
        confH = this.canvasHeight - this.conf.top;
      }
      if (confH < 0) {
        confH = 0;
      }
      this.conf.height = confH;
    },
    changImgType() {
      if (this.conf.imgType === "1") {
        this.conf.name = "BarCode";
        this.conf.imgSrc = "/pro/profile/barCode.jpg";
      } else {
        this.conf.name = "QRCode";
        this.conf.imgSrc = "/pro/profile/QRCode.jpg";
      }
    },
    changeName() {},
    // 修改字体颜色
    changeFontColor(index) {
      this.conf.fontColor = this.colorList[index].color;
    },

    // 修改填充色背景色
    changeBgColor(index) {
      this.conf.bgColor = this.colorList[index].color;
    },

    showLogicDialog() {
      this.$refs.logicRef.open();
      console.log(12333333);
    },
    getLogic(val) {
      console.log(val);
      this.conf.showLogic = val;
    },

    changeIsDeviceCode(){
      console.log('changetodeevicecode')
      if(this.conf.isDeviceCode){
        this.conf.datasetField=""
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.TumengQRCodeEdit {
  margin: 8px;
  color: white;
  height: calc(100% - 16px);
  overflow: auto;

  .prop-pane {
    // 添加视频按钮变宽
    > button.el-button.el-button--default.el-button--small {
      width: 100%;
    }

    // 展示图片列表的div
    .img-item {
      margin: 0 12px 8px 4px;
      padding: 4px;
      border: 1px dashed white;
      width: calc(100% - 26px);
      height: 150px;
      text-align: left;
      position: relative;

      > img {
        float: left;
      }

      > div {
        float: left;
      }

      // 删除图片按钮
      > button.el-button.el-button--default.el-button--mini.is-circle {
        padding: 0;
        position: absolute;
        right: 0;
        top: 59px;
        transform: translate(5px, -50%);
      }

      // 让图片时长输入框和图片之间有个间距
      div.el-input-number {
        margin-top: 8px;
        text-align: left;
      }

      // 图片时长输入框的增加、减小按钮
      ::v-deep span.el-input-number__increase,
      ::v-deep span.el-input-number__decrease {
        display: none;
      }

      > div {
        // 图片时长输入框行高
        > span {
          display: inline-block;
          line-height: 28px;
          height: 28px;
          color: #000;
        }
      }
    }
  }
  .style-pane {
    // 横纵坐标、宽高样式
    @import "../../../assets/style/ltwh";

    .custom-smaller-slider-btn2 {
      // 旋转和透明度的slider的拖拽点变小
      ::v-deep .el-slider__button {
        border-width: 1px;
        width: 10px;
        height: 10px;
      }

      // 旋转和透明度的slider宽度
      ::v-deep .el-slider {
        width: calc(100% - 76px);
        margin-right: 16px;
        float: left;
      }

      // 隐藏旋转和透明度数字输入框的增加、减少按钮
      ::v-deep span.el-input-number__increase,
      ::v-deep span.el-input-number__decrease {
        display: none;
      }

      // 让旋转和透明度的数字输入框便的正常
      ::v-deep input.el-input__inner {
        padding: 0;
      }

      // 指定旋转和透明度的输入框宽度宽度
      ::v-deep .el-input-number.el-input-number--mini {
        width: 60px;
        float: left;
        margin-top: 5px;
      }
    }
  }
}
::v-deep .el-tabs__item.is-active {
  background-color: #f5f7fa;
  border-radius: 5px 5px 0 0;
}

.logicBtn {
  position: absolute;
  top: 0px;
  right: -15px;
  z-index: 101;
  &.el-button.el-button--mini {
    font-size: 12px;
  }
}
</style>

<style lang="scss">
.myQREdit .el-input-group__append,
.myQREdit .el-input-group__prepend {
  padding: 0 10px;
}
</style>